module.exports = __webpack_public_path__ + "static/IMG_2434-ff8c1084065e9403d75e75bf841df754.jpg";